import { actions as groupActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import { toGroupIfVariantExists } from '../helpers/toGroupIfVariantExists';

export const createGroup = (paperId: string, sizeId: string, groupId: string): PhotoPrintsPdpThunk => {

    return (dispatch, getState) => {

        const state = getState();
        const groupExists = state.project.groups.ids.includes(groupId);

        if (!groupExists) {
            const group = toGroupIfVariantExists(state, paperId, sizeId, groupId);
            if (group) {
                dispatch(groupActions.add(group));
            }
        }
    };
};